import * as React from "react";

type TechTicketData = [number, (unreadTechTicketCount: number) => void];

const TechTicketContext = React.createContext<TechTicketData>([0, () => ({})]);

export default TechTicketContext;